import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Delisandwiches';
render(<App data-id="element-339" />, document.getElementById('root'));